<template>
    <div>
        <site-navbar :activeSite="activeSociete ? activeSociete.d_nomSociete : ''"></site-navbar>
        <div class="main-navbar-wrapper">
            <nav class="main-navbar">
                <img class="navbar-logo logo" alt="Giordano Patrimoine"
                    src="../../assets/images/patrimoine/giordano-patrimoine.svg" />
                <div class="navbar-link-container" v-bind:class="{ menuOpen: menuOpen }">
                    <router-link :to="{ name: 'PatrimoineHome' }">Accueil</router-link>
                    <router-link :to="{ name: 'Epargne' }">Epargne & retraite</router-link>
                    <router-link :to="{ name: 'Ingenierie' }">Ingénierie & conseils patrimoniaux</router-link>
                    <router-link :to="{ name: 'PatrimoineAgence' }">Notre équipe</router-link>
                    <router-link :to="{ name: 'PatrimoineContact' }">Contact</router-link>
                    <router-link :to="{ name: 'GPRecrutementForm'}" class="join-btn">
                        Nous rejoindre
                    </router-link>
                </div>
                <div class="navbar-right-container">
                    <button class="navbar-account-link cg-btn cg-btn-primary">
                        <user-icon></user-icon>
                        <p>Mon compte</p>
                    </button>
                    <router-link :to="{ name: 'GPRecrutementForm'}" class="join-btn">
                        Nous rejoindre
                    </router-link>
                    <button class="burger-btn" v-on:click="(menuOpen = !menuOpen)">
                        <img src="../../assets/icons/icn-menu.svg">
                    </button>
                </div>
            </nav>
        </div>
        <main>
            <router-view />
        </main>

        <footer>
            <div class="footer-wrapper">
                <div class="footer flex">
                    <div>
                        <img class="logo" alt="Giordano Patrimoine"
                            src="../../assets/images/patrimoine/giordano-patrimoine.svg" />
                        <p v-html="activeSociete ? activeSociete.d_mentions : '' "></p>
                    </div>
                    <div class="contact-container">
                        <h4>Vous avez une question</h4>
                        <p>Nos équipes se tiennent à votre disposition pour toutes interrogations sur nos biens et
                            services.
                        </p>
                        <router-link :to="{ name: 'PatrimoineContact' }">
                            <button class="cg-btn cg-btn-primary">Contactez-nous</button>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="legal-mention-wrapper">
                <div class="legal-mention flex">
                    <p>{{ activeSociete ? activeSociete.d_nomSociete : '' }}.com - 2023 Tous droits réservés.</p>
                    <router-link :to="{ name: 'GPMentionsLegales' }">
                        Mentions légales
                    </router-link>
                    <router-link :to="{ name: 'PatrimoineContact' }">
                        Nous contacter
                    </router-link>
                    <p v-html="activeSociete ? activeSociete.d_telSociete : '' "></p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import DataApi from 'fm-data-api'
import NewsletterBar from '../Components/NewsletterBar.vue'
import SiteNavbar from '../Components/SiteNavbar.vue';
import FacebookIcon from '../Components/FacebookIcon.vue';
import LinkedinIcon from '../Components/LinkedinIcon.vue';
import UserIcon from '../Components/UserIcon.vue';

export default {
    name: 'Patrimoine',
    components: {
        SiteNavbar,
        NewsletterBar,
        FacebookIcon,
        LinkedinIcon,
        UserIcon
    },
    data: () => {
        return {
            menuOpen: false,
            activeSociete: {}
        }
    },
    watch:{
        $route (to, from){
            this.menuOpen = false;
        }
    },
    async beforeMount() {
        const options = {
            apiUrl: this.$apiUrl,
            databaseName: this.$databaseName,
            token: await this.$getMainToken()
        }
        this.dataApi = new DataApi(options)
        this.dataApi.findRecords('W_Societe', { 'd_codeSociete': 'gp' }, '', '', '')
        .then((response) => {
            this.activeSociete = response[0] ? response[0]['fieldData'] : null
        })
    }
}
</script>

<style lang="scss" scoped>
::v-deep div {
    --color-primary: #0cbfdd;
}

::v-deep .patrimoine-link {
    color: var(--color-primary) !important;
    font-weight: 600;
    cursor: default;

    &:hover {
        text-decoration: none;
    }
}
</style>